"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallPagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ChevronIcon = require("../../svgs/ChevronIcon");

var _BorderBox = require("../BorderBox");

var _Flex = require("../Flex");

var _Link = require("../Link");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** SmallPagination */
var SmallPagination = function SmallPagination(props) {
  var previous = props.pageCursors.previous,
      getHref = props.getHref,
      onClick = props.onClick,
      onNext = props.onNext,
      hasNextPage = props.hasNextPage;

  var handlePrevClick = function handlePrevClick(event) {
    if (previous) {
      onClick(previous.cursor, previous.page, event);
    }
  };

  var handleNextClick = function handleNextClick(event) {
    onNext(event, nextPage);
  };

  var nextPage = ((previous === null || previous === void 0 ? void 0 : previous.page) || 0) + 2;
  return /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "row",
    height: "40px",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(PrevButton, {
    enabled: !!previous,
    getHref: getHref,
    onClick: handlePrevClick,
    page: previous === null || previous === void 0 ? void 0 : previous.page
  }), /*#__PURE__*/_react.default.createElement(NextButton, {
    enabled: hasNextPage,
    getHref: getHref,
    onClick: handleNextClick,
    page: nextPage
  }));
};

exports.SmallPagination = SmallPagination;
SmallPagination.displayName = "SmallPagination";
var Wrapper = (0, _styledComponents.default)(_BorderBox.BorderBox).withConfig({
  displayName: "SmallPagination__Wrapper",
  componentId: "sc-1ld47ec-0"
})(["border-radius:3px;border-width:2px;padding:0;width:50%;a{height:100%;width:100%;> div{align-items:center;height:100%;}}"]);

var PrevButton = function PrevButton(props) {
  var enabled = props.enabled,
      getHref = props.getHref,
      onClick = props.onClick,
      page = props.page;
  var opacity = enabled ? 1 : 0.1;
  var href = "";

  if (enabled && page && typeof getHref !== "undefined") {
    href = getHref(page);
  }

  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    mr: 0.5,
    opacity: opacity
  }, /*#__PURE__*/_react.default.createElement(_Link.Link, {
    href: href,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    justifyContent: "flex-start",
    pl: 1
  }, /*#__PURE__*/_react.default.createElement(_ChevronIcon.ChevronIcon, {
    direction: "left"
  }))));
};

PrevButton.displayName = "PrevButton";

var NextButton = function NextButton(props) {
  var enabled = props.enabled,
      getHref = props.getHref,
      onClick = props.onClick,
      page = props.page;
  var opacity = enabled ? 1 : 0.1;
  var href = "";

  if (enabled && page && typeof getHref !== "undefined") {
    href = getHref(page);
  }

  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    ml: 0.5,
    opacity: opacity
  }, /*#__PURE__*/_react.default.createElement(_Link.Link, {
    href: href,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    justifyContent: "flex-end",
    pr: 1
  }, /*#__PURE__*/_react.default.createElement(_ChevronIcon.ChevronIcon, {
    direction: "right"
  }))));
};

NextButton.displayName = "NextButton";
//# sourceMappingURL=SmallPagination.js.map